import React
  from 'react';

import {
  useTranslation,
} from 'react-i18next';

import ConsentAgreementContent
  from './ConsentAgreementContent';


export default function PolicyAndPermissionForm({
  policyAgreed1,
  setPolicyAgreed1,
  policyAgreed2,
  setPolicyAgreed2,
  onNext,
}) {
  const { t } =
    useTranslation(
      'app',
    );


  return (
    <section className="signup-section">
      <div className="signup-section-title">
        <h2>
          {t(
            'signup.agreement.title'
          )}
        </h2>
      </div>


      <div className="signup-agreement-document">
        <ConsentAgreementContent />
      </div>


      <div className="signup-agreement-options">
        <label className="signup-checkbox">
          <input
            type="checkbox"
            checked={
              policyAgreed1
            }
            onChange={(
              event,
            ) =>
              setPolicyAgreed1(
                event.target.checked,
              )
            }
          />

          <span>
            {t(
              'signup.agreement.requiredAgreement'
            )}
          </span>
        </label>


        <label className="signup-checkbox">
          <input
            type="checkbox"
            checked={
              policyAgreed2
            }
            onChange={(
              event,
            ) =>
              setPolicyAgreed2(
                event.target.checked,
              )
            }
          />

          <span>
            {t(
              'signup.agreement.informationAgreement'
            )}
          </span>
        </label>
      </div>


      <div className="signup-form-actions single">
        <button
          type="button"
          className="signup-primary-button"
          onClick={
            onNext
          }
        >
          {t(
            'common.next'
          )}
        </button>
      </div>
    </section>
  );
}